import React from "react";

export default function DroneDashStreak({ game, onClose }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
      <div className="w-[85%] max-w-sm rounded-3xl bg-gradient-to-br from-sky-500 via-cyan-500 to-emerald-500 p-[2px]">
        <div className="rounded-3xl bg-slate-950 p-6 text-center">
          <div className="text-6xl animate-bounce">🔥</div>
          <div className="mt-3 text-2xl font-black text-cyan-300">Streak Active!</div>
          <div className="mt-2 text-4xl font-black text-white">{game.streak} 🔥 Days</div>
          <div className="mt-2 text-sm text-slate-300">Fly once a day to keep it going 🚁</div>
          <button
            onClick={onClose}
            className="mt-5 w-full rounded-xl bg-slate-800 text-white py-2.5 font-semibold"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
